function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import Common from "../components/includes/Common";
import { Skeleton, Button, Spin, Modal, Alert } from 'antd';
import { Container, Row, Col, Table } from 'react-bootstrap';
import { PencilFill, Eyedropper, EyeFill, HeartPulseFill, XCircleFill, CheckCircleFill } from 'react-bootstrap-icons';
import LaboForm from "../components/forms/LaboForm";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var ProcessCustomers = function ProcessCustomers() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    customers = _useState2[0],
    setCustomers = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    processModalVisible = _useState6[0],
    setProcessModalVisible = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    processModalSpinVisible = _useState8[0],
    setProcessModalSpinVisible = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    dataUpdated = _useState10[0],
    setDataUpdated = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    laboFormVisible = _useState12[0],
    setLaboFormVisible = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    medFormVisible = _useState14[0],
    setMedFormVisible = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    optaFOrmVisible = _useState16[0],
    setOptaFormVisible = _useState16[1];
  var _useState17 = useState(''),
    _useState18 = _slicedToArray(_useState17, 2),
    errorMessage = _useState18[0],
    setErrorMessage = _useState18[1];
  var _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    selectedCustomer = _useState20[0],
    setSelectedCustomer = _useState20[1];
  var handleProcess = function handleProcess(customer) {
    setSelectedCustomer(customer);
    setProcessModalSpinVisible(true);
    setProcessModalVisible(true);
    setLaboFormVisible(false);
    setMedFormVisible(false);
    setOptaFormVisible(false);
    setErrorMessage('');
    axios.post(Common.baseApiUrl + 'authenticateuser', {
      id: Common.currentUser.id
    }).then(function (response) {
      setProcessModalSpinVisible(false);
      if (response.data.authenticated == true) {
        localStorage.setItem('userData', JSON.stringify(response.data.user));
        if (response.data.user.role == 2 || response.data.user.role == 9) {
          //LABO USER  
          setLaboFormVisible(true);
          console.log('Labo');
        }
        if (response.data.user.role == 3) {
          //MED USER  
          setMedFormVisible(true);
          console.log('Med');
        }
        if (response.data.user.role == 4) {
          //OPTA USER 
          setOptaFormVisible(true);
          console.log('Opt');
        }
        if (response.data.user.role != 2 && response.data.user.role != 3 && response.data.user.role != 4 && response.data.user.role != 5 && response.data.user.role != 10) {
          setErrorMessage("Vous n'avez pas accès à cette fonctionnalité");
          console.log('no role');
        }
      } else {
        console.log('user not connected');
        navigate('/');
      }
    })["catch"](function (error) {
      setProcessModalSpinVisible(false);
    });
  };
  useEffect(function () {
    axios.all([axios.get(Common.baseApiUrl + 'getcurrentdayqueue/' + Common.currentUser.id), axios.get(Common.baseApiUrl + 'getcurrentdaysampled/' + Common.currentUser.id)]).then(function (response) {
      setIsDataLoading(false);
      if (response.data.status == 200) {
        setCustomers(response.data.customers);
      }
    })["catch"](function (error) {
      setIsDataLoading(false);
    });
  }, [dataUpdated]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 9,
          md: 9,
          sm: 10,
          children: [/*#__PURE__*/_jsxs(Modal, {
            title: "Proc\xE9dure de traitement candidat",
            visible: processModalVisible,
            onCancel: function onCancel() {
              setProcessModalVisible(false);
            },
            destroyOnClose: true,
            footer: null,
            cancelText: "Annuler",
            children: [selectedCustomer != null && /*#__PURE__*/_jsxs("div", {
              style: {
                background: '#FCB917',
                padding: '10px',
                borderRadius: '0px 10px 10px 10px'
              },
              children: [/*#__PURE__*/_jsxs("h5", {
                children: ["RNC : ", selectedCustomer.rnc]
              }), /*#__PURE__*/_jsxs("p", {
                children: [/*#__PURE__*/_jsx("b", {
                  children: "Pr\xE9nom : "
                }), selectedCustomer.firstname, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
                  children: "Nom : "
                }), selectedCustomer.lastname, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
                  children: "Tel : "
                }), selectedCustomer.mobile, /*#__PURE__*/_jsx("br", {})]
              })]
            }), processModalSpinVisible && /*#__PURE__*/_jsx("div", {
              style: {
                margin: '0px auto',
                padding: '20px'
              },
              children: /*#__PURE__*/_jsx(Spin, {})
            }), errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
              type: "error",
              message: errorMessage,
              showIcon: true
            }), laboFormVisible && /*#__PURE__*/_jsx(LaboForm, {
              handler: function handler() {
                setDataUpdated(true);
              },
              customer: selectedCustomer
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "white-bg cool-radius",
            children: [customers && /*#__PURE__*/_jsxs(Table, {
              bordered: true,
              children: [/*#__PURE__*/_jsx("thead", {
                children: /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("th", {
                    children: "Date"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "RNC"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Pr\xE9nom"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Nom"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "T\xE9l\xE9phone"
                  }), /*#__PURE__*/_jsx("th", {
                    children: /*#__PURE__*/_jsx(Eyedropper, {
                      size: 22
                    })
                  }), /*#__PURE__*/_jsx("th", {
                    children: /*#__PURE__*/_jsx(HeartPulseFill, {
                      size: 22
                    })
                  }), /*#__PURE__*/_jsx("th", {
                    children: /*#__PURE__*/_jsx(EyeFill, {
                      size: 22
                    })
                  }), /*#__PURE__*/_jsx("th", {})]
                })
              }), /*#__PURE__*/_jsx("tbody", {
                children: customers.map(function (c) {
                  return /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: new Date(c.created_at).toLocaleDateString('Fr', {
                        month: 'long',
                        day: 'numeric',
                        year: 'numeric'
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: c.rnc
                    }), /*#__PURE__*/_jsx("td", {
                      children: c.firstname
                    }), /*#__PURE__*/_jsx("td", {
                      children: c.lastname
                    }), /*#__PURE__*/_jsx("td", {
                      children: c.mobile
                    }), /*#__PURE__*/_jsxs("td", {
                      children: [c.laboresult_id == null && /*#__PURE__*/_jsx(XCircleFill, {
                        style: {
                          color: '#EA696B'
                        },
                        size: 22
                      }), c.laboresult_id != null && /*#__PURE__*/_jsx(CheckCircleFill, {
                        style: {
                          color: '#198794'
                        },
                        size: 22
                      })]
                    }), /*#__PURE__*/_jsxs("td", {
                      children: [c.medecineresult_id == null && /*#__PURE__*/_jsx(XCircleFill, {
                        style: {
                          color: '#EA696B'
                        },
                        size: 22
                      }), c.medecineresult_id != null && /*#__PURE__*/_jsx(CheckCircleFill, {
                        style: {
                          color: '#198794'
                        },
                        size: 22
                      })]
                    }), /*#__PURE__*/_jsxs("td", {
                      children: [c.optaresult_id == null && /*#__PURE__*/_jsx(XCircleFill, {
                        style: {
                          color: '#EA696B'
                        },
                        size: 22
                      }), c.optaresult_id != null && /*#__PURE__*/_jsx(CheckCircleFill, {
                        style: {
                          color: '#198794'
                        },
                        size: 22
                      })]
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Button, {
                        type: "default",
                        onClick: function onClick() {
                          handleProcess(c);
                        },
                        children: /*#__PURE__*/_jsx(PencilFill, {
                          size: 22
                        })
                      })
                    })]
                  }, c.id);
                })
              })]
            }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })]
        })
      })
    })
  });
};
export default ProcessCustomers;